import { useAuthStore } from '@/features/auth/store';

const EDIT_ROLES = ['admin', 'sales-director'];

/** Only admins and sales directors may edit sections and verify whole requests. */
export const useCanEditVerification = () =>
  useAuthStore((s) => EDIT_ROLES.some((role) => role in s.profile.roles));
